import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Icon } from '@vio/atlas/Icon';
import { Text } from '@vio/atlas/Text';
import format from 'date-fns/format';
import { ContentHotel, Hotel } from '@findhotel/sapi';
const ToastWrapper = /*#__PURE__*/styled('div')({
  name: "ToastWrapper",
  class: "tw6q9rf",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1h4ec20",
  propsAsIs: false
});
export const PriceWatchToastMessage = ({
  enabled,
  hotel,
  checkIn,
  checkOut,
  shouldShowNavigationIcon
}: {
  hotel: ContentHotel | Hotel;
  checkIn: string;
  checkOut: string;
  enabled: boolean;
  shouldShowNavigationIcon?: boolean;
}) => {
  const intl = useIntl();
  const values = {
    hotel: <Text tag="span" variant="titleS">
        {hotel?.hotelName}
      </Text>,
    checkIn: <Text tag="span" variant="titleS">
        {format(new Date(checkIn), 'MMM dd')}
      </Text>,
    checkOut: <Text tag="span" variant="titleS">
        {format(new Date(checkOut), 'MMM dd')}
      </Text>
  };
  const enabledMessage = intl.formatMessage({
    id: 'priceWatchToggle.enabledMessage',
    defaultMessage: 'You’re tracking prices at {hotel} {checkIn} - {checkOut}'
  }, values);
  const disabledMessage = intl.formatMessage({
    id: 'priceWatchToggle.disabledMessage',
    defaultMessage: 'You’re no longer tracking prices at {hotel} {checkIn} - {checkOut}'
  }, values);
  return enabled ? shouldShowNavigationIcon ? <ToastWrapper>
        <span>{enabledMessage}</span>
        <IconWrapper>
          <Icon size="md" name="ChevronRight" />
        </IconWrapper>
      </ToastWrapper> : <span>{enabledMessage}</span> : <span>{disabledMessage}</span>;
};
export const PriceWatchToastIcon = ({
  enabled
}: {
  enabled: boolean;
}) => <Icon name={enabled ? 'BellRinging' : 'BellOff'} size="md" />;

require("./PriceWatchToastMessage.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceWatchToastMessage.tsx");